import { Vector3, Quaternion } from 'three';
import { ViewerCommand } from './ViewerCommand';
import { ViewerEvents } from '../../Viewer';
export class MoveObjectsCommand extends ViewerCommand {
    constructor(objects, viewer, newParent, newBefore = null) {
        super(viewer, objects);
        this.originalTransformations = [];
        this.type = 'MoveObjectsCommand';
        this.name = this.composeName();
        if (objects.length < 1) {
            throw Error('objects must not be an empty array');
        }
        if (objects[0].parent === null || objects.some((object) => object.parent !== objects[0].parent)) {
            throw Error('objects must have non null parent');
        }
        this.oldParent = objects[0].parent;
        this.oldIndices = objects.map((object) => this.oldParent.children.indexOf(object));
        objects.forEach((object) => {
            const position = new Vector3();
            const rotation = new Quaternion();
            object.getWorldPosition(position);
            object.getWorldQuaternion(rotation);
            this.originalTransformations.push({ position, rotation });
        });
        this.oldIndices.sort((a, b) => a - b);
        this.objects = this.oldIndices.map((index) => this.oldParent.children[index]);
        this.newParent = newParent;
        if (newBefore) {
            this.newIndex = newParent.children.indexOf(newBefore);
        }
        else {
            this.newIndex = newParent.children.length;
        }
    }
    execute() {
        this.oldParent.remove(...this.objects);
        const children = this.newParent.children;
        children.splice(this.newIndex, 0, ...this.objects);
        this.objects.forEach((object, idx) => {
            object.parent = this.newParent;
            // Resolve an issue with shifted position
            // Need to fix it according to the new parent position shift
            const { position, rotation } = this.originalTransformations[idx];
            const localPosition = new Vector3().copy(position);
            this.newParent.worldToLocal(localPosition);
            object.position.copy(localPosition);
            object.quaternion.copy(rotation);
        });
        this.viewer.emit(ViewerEvents.SceneGraphChanged, true);
    }
    undo() {
        this.newParent.remove(...this.objects);
        const children = this.oldParent.children;
        this.oldIndices.forEach((index, i) => {
            children.splice(index, 0, this.objects[i]);
            this.objects[i].parent = this.oldParent;
        });
        this.viewer.emit(ViewerEvents.SceneGraphChanged, true);
    }
    update(cmd) {
        throw new Error(`${this.type} can not be updated`);
    }
    toJSON() {
        const output = super.toJSON();
        output.oldParentUUID = this.oldParent.uuid;
        output.oldIndices = this.oldIndices;
        output.newParentUUID = this.newParent.uuid;
        output.newIndex = this.newIndex;
        return output;
    }
    fromJSON(json) {
        var _a, _b;
        super.fromJSON(json);
        this.oldParent = (_a = this.viewer.getObjectByUUID(json.oldParentUUID)) !== null && _a !== void 0 ? _a : this.viewer.getScene();
        this.newParent = (_b = this.viewer.getObjectByUUID(json.newParentUUID)) !== null && _b !== void 0 ? _b : this.viewer.getScene();
        this.oldIndices = json.oldIndices;
        this.newIndex = json.newIndex;
    }
}
